import { useCallback, useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import { useEmbeddedContext } from './embeddedContext';
import { jsx as _jsx } from "react/jsx-runtime";
const OPEN_EXTERNAL_LINK = 'OPEN_EXTERNAL_LINK';
export function useOpenExternalLinkSender() {
  const {
    sendMessage
  } = useEmbeddedContext();
  return useCallback(href => sendMessage(OPEN_EXTERNAL_LINK, {
    href
  }), [sendMessage]);
}
export function useOpenExternalLinkReceiver() {
  const rootRef = useRef(document.createElement('div'));
  const linkRef = useRef(null);
  const [href, setHref] = useState(null);
  const handleClickLink = () => {
    if (linkRef.current) {
      linkRef.current.click();
      setHref(null);
    }
  };
  useEffect(() => {
    if (href) {
      const currentRootRef = rootRef.current;
      document.body.appendChild(currentRootRef);
      ReactDOM.render( /*#__PURE__*/_jsx("a", {
        target: "_blank",
        rel: "noopener noreferrer",
        href: href,
        ref: linkRef,
        hidden: true
      }), currentRootRef);
      setTimeout(handleClickLink);
      return () => {
        ReactDOM.unmountComponentAtNode(currentRootRef);
        document.body.removeChild(currentRootRef);
      };
    }
  }, [href]);
  return {
    type: OPEN_EXTERNAL_LINK,
    onMessageReceived: payload => {
      if (typeof payload.href !== 'string') {
        const error = `Error validating 'href' type in ${OPEN_EXTERNAL_LINK} message. Received ${typeof payload.href}.`;
        console.error(error);
        return;
      }
      setHref(payload.href);
    }
  };
}